import { createFileRoute } from '@tanstack/react-router'
import PackagesPageClient from '#/components/packages/PackagesPageClient'
import { useFeatureFlags } from '#/lib/queries/index'
import { FeatureDisabledNotice } from '#/components/FeatureDisabledNotice'

function PackagesRoute() {
  const { packagesEnabled, isLoading } = useFeatureFlags()
  if (isLoading) return null
  if (!packagesEnabled) return <FeatureDisabledNotice feature="Packages" />
  return <PackagesPageClient />
}

export const Route = createFileRoute('/_authenticated/$slug/packages')({
  component: PackagesRoute,
})
